export const routeNameHospitalVersion = {
    HOMEPAGE: '/hospitalversion1/',
    CONTACTUS: '/hospitalversion1/contact',
    BOOKAPPOINTMENT: '/hospitalversion1/appointment',
    DOCTORDETAILS: '/hospitalversion1/details',
  }